// extracted by mini-css-extract-plugin
export var container = "_18-0";
export var disabled = "_18-4";
export var fullWidth = "_18-3";
export var lined = "_18-1";
export var selected = "_18-5";
export var tab = "_18-2";